import { DealVersion, DealUserRole } from '../../types/deal.types';
import { Session } from '../../types/session.types';

export function dealRoleForUser(
  deal: DealVersion,
  session?: Session.SessionModel
): DealUserRole {
  if (session && session.deptId) {
    const userDeptId = session.deptId;
    if (deal.seniorManager && userDeptId === deal.seniorManager.id) {
      return DealUserRole.bookrunner;
    } else if (
      deal.syndicate &&
      deal.syndicate.some(
        (member) =>
          userDeptId === member.deptId || userDeptId === member.orionId
      )
    ) {
      return DealUserRole.syndicate;
    } else if (
      (deal.issuer && userDeptId === deal.issuer.id) ||
      (deal.compositeDeal &&
        deal.series.some(
          (series) =>
            series.conduitIssuerDepartment &&
            series.conduitIssuerDepartment.id === userDeptId
        ))
    ) {
      return DealUserRole.issuer;
    } else if (
      (deal.obligor && deal.obligor.id === userDeptId) ||
      (deal.series &&
        deal.series.some(
          (series) => series.obligor && series.obligor.id === userDeptId
        ))
    ) {
      return DealUserRole.obligor;
    } else if (
      deal.financialAdvisors &&
      deal.financialAdvisors.some((advisor) => userDeptId === advisor.id)
    ) {
      return DealUserRole.financialAdvisor;
    } else if (
      deal.bondCounsels &&
      deal.bondCounsels.some((counsel) => userDeptId === counsel.id)
    ) {
      return DealUserRole.counsel;
    } else {
      return DealUserRole.none;
    }
  } else {
    return DealUserRole.none;
  }
}
